import { render } from "./SetKitchenDisplayDialog.vue?vue&type=template&id=15fd84da"
import script from "./SetKitchenDisplayDialog.vue?vue&type=script&lang=js"
export * from "./SetKitchenDisplayDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QTooltip});
